import { CoachingTranscript } from '../../../coaching-base/general';
import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

export interface UpdateTranscript {
    transcript: CoachingTranscript;
}

export const updateTranscript = createAction<ActionType, UpdateTranscript>(
    ActionType.COACHING_DETAIL__TD__UPDATE_TRANSCRIPT,
);

export interface UpdateTranscriptResult extends UpdateTranscript {}

export const updateTranscriptResult = createAction<
    ActionType,
    UpdateTranscriptResult
>(ActionType.COACHING_DETAIL__TD__UPDATE_TRANSCRIPT_RESULT);
